module.exports = __webpack_public_path__ + "static/media/frontend.2962fda9.svg";